import { render, staticRenderFns } from "./SupplierFile.vue?vue&type=template&id=02f5118e&scoped=true"
import script from "./SupplierFile.vue?vue&type=script&lang=js"
export * from "./SupplierFile.vue?vue&type=script&lang=js"
import style0 from "./SupplierFile.vue?vue&type=style&index=0&id=02f5118e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f5118e",
  null
  
)

export default component.exports